module.exports = __webpack_public_path__ + "img/icon.106053ae.png";